module.exports = __webpack_public_path__ + "static/media/EmailActive.aa5192bf.svg";